<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">XML de nota fiscal</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
       {{ order.invoice.xml }}
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Sair</button>
          <button type="button" class="btn btn--success" data-label="Clique para copiar" v-clipboard:copy="order.invoice.xml">
            <i class="icon icon-copy2"></i>
          </button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      checked: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      },
      order: {
        type: Object,
        required: true
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      cancel () {
        this.isVisible = false
        this.checked = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

<style lang="sass" scoped>
  .c-modalCard
    width: 900px
    align-content: center


  .c-modal--sm
    .c-modal__content
      max-width: 900px
      align-content: center

</style>



// WEBPACK FOOTER //
// ModalInvoice.vue?0c392c98